import type { SearchResult } from '@rover/types/src/apiResponses/FetchSearchResponse';

const getSitterLocation = (
  neighborhood: SearchResult['neighborhood'],
  city: SearchResult['city'],
  state: SearchResult['state'],
  zip: SearchResult['zip']
): string => {
  return [neighborhood, city, state, zip].filter(Boolean).join(', ');
};

export default getSitterLocation;
